import { API_CUSTOM_HEADERS, ApiResponse, ChatConversation } from '@endion/types';
import { callApi, getEndpoint } from '../utils/api.utils';

type GetConversationParams = {
  conversationKey: string;
  chatbotApiKey: string;
};

export function findConversation({ conversationKey, chatbotApiKey }: GetConversationParams) {
  if (!conversationKey) return null;
  const headers = new Headers();
  headers.set(API_CUSTOM_HEADERS.X_CHATBOT_API_KEY, chatbotApiKey);

  // A new conversation is created if the conversationKey is missing or is invalid
  return callApi<ApiResponse<ChatConversation | null>>(getEndpoint(`conversation/${conversationKey}`), {
    method: 'GET',
    headers,
  });
}
